/* eslint-disable @typescript-eslint/no-require-imports */

export const GradientOverlay = require('./gradient-overlay.png');
